const state = {
	campus: JSON.parse(localStorage.getItem('campus')),
}
  
  const mutations = {
    CAMPUS(state, val) {
      state.campus = val;
      localStorage.setItem('campus', JSON.stringify(val))
    }
  };
  
  const actions = {
    campus({ commit }, val) {
      commit("CAMPUS", val);
    }
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  };
  